import React, { useState } from 'react';
// import { faPhone, faPrint, faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF,faWhatsapp, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';

const Footer = () => {

    const scrollToTop = ()=>{
        window.scrollTo({
          top: 0,
          behavior: 'smooth', 
        });
      }
    
    // const contactdetails = [
    //     {
    //         icon : faMapMarkerAlt,
    //         text : "Limited. 22-UTC , EU",
    //         href : "https://maps.app.goo.gl/VYdHMD6NEreRuvP26"
    //     },
    //     {
    //         icon : faEnvelope,
    //         text : "Support@emtheme.com",
    //         href : "mailto:team@dreamvisionhomes.com"
    //     },
    //     {
    //         icon : faPhone,
    //         text : "(00)-213 1234567",
    //         href : "tel:2131234567"
    //     },
    //     {
    //         icon : faPrint,
    //         text : "(00)-213 1879017",
    //         href : "fax:+2131879017"
    //     },
    // ]

    const footerdata = [
        {
            id : 1,
            title : "Quick Link",
            links : [
                {
                    url : "/",
                    title : "Home"
                },
                {
                    url : "/blog",
                    title : "Blog"
                }
            ]
        },
        {
            id : 2,
            title : "About Us",
            links : [
                {
                    url : "/about",
                    title : "Company"
                },
                {
                    url : "/product",
                    title : "Customisation"
                },
                {
                    url : "/?scroll=clients",
                    title : "Our Clients"
                },
                
            ]
        },
        {
            id : 3,
            title : "Collections",
            links : [
                {
                    url : "/product",
                    title : "Necklaces"
                },
                {
                    url : "/product",
                    title : "Pendants"
                },
                {
                    url : "/product",
                    title : "Rings"
                },
                {
                    url : "/product",
                    title : "Bangles"
                }
            ]
        },
        {
            id : 4,
            title : "Support",
            links : [
                
                {
                    url : "tel:+917012065100",
                    title : "70120 65100"
                },
                {
                    url : "mailto:accfabgoldjewellery@gmail.com",
                    title : "accfabgoldjewellery@gmail.com "
                },  
            ],
            socialIcons: [  
                {
                    icon : faInstagram,
                    link : "https://www.instagram.com/fabgold_official/"
                },
                {
                    icon: faFacebookF,
                    link: "https://www.facebook.com/share/1C5DzmY64D/"
                },
                {
                    icon : faWhatsapp , 
                    link : "https://wa.me/917012065100"
                }
            ]
        }
    ]

    const [expandedList, setExpandedList] = useState(null);

    const toggleList = (id) => {
        setExpandedList(expandedList === id ? null : id);
    };
    
  return (
    <footer className='relative pt-[90px] pb-[10px] bg-secondary2 text-secondary1'>
        {/* container */}
        <div className='flex lg:flex-row md:flex-row max-sm:flex-col sm:mx-[60px] lg:mx-[174px] max-sm:ml-[40px]'>
            {footerdata.map((data)=>(
            <div key={data.id} className='flex flex-col px-[15px] md:w-[33%] max-sm:w-[78%] max-sm:mb-8'>
                <div 
                    className='max-sm:flex max-sm:flex-row max-sm:justify-between'
                    onClick={()=> toggleList(data.id)}
                >
                    <span className='lg:mb-[23.5px] text-[1rem] text-gold'>{data.title}</span> 
                    <span className='lg:hidden md:hidden sm:hidden'>{expandedList === data.id ? '-' : "+"} </span>
                </div>
               
                <ul className={`lg:block md:block sm:block ${expandedList === data.id ? 'block' : 'hidden'}`}>
                    {data.links.map((data,index)=>(
<Link to={data.url} onClick={scrollToTop}>
  <li className='py-[12px] hover:cursor-pointer hover:text-hover'>{data.title}</li>
</Link>

                   ))}
                   <ul className='flex flex-row gap-14 mt-5'>
                    {data?.socialIcons?.map((socialIcons,index)=> (
                        <li key={index}>
                            <a className='text-[13px] leading-[15px] text-[#fff] w-[30px] h-[30px] rounded-[100%] py-[7px] block text-center bg-tertary2 hover:bg-gold transition-transform transform-gpu hover:scale-110' href={socialIcons.link}> 
                                <FontAwesomeIcon icon={socialIcons.icon} /> 
                            </a>
                        </li>
                    ))}
                </ul>
                </ul>
            </div>
            ))}
            
        </div>
        <hr className='lg:mx-36 md:mx-36 max-sm:mx-16 sm:mx-14 sm:mt-11 lg:mt-20 md:mt-20 max-sm:mt-14 relative border-t-[1px] border-gold'/>
        <div className='flex lg:flex-row md:flex-col max-sm:flex-col sm:flex-col lg:mx-36 md:mx-28 md:justify-between lg:justify-betweenpt-4 mt-[34px] '>
            <div className='flex lg:flex-row md:flex-col max-sm:flex-col  sm:flex-col sm:items-center max-sm:items-center md:items-center'> 
                <p className='sm:text-[14px] max-sm:text-[14px]  text-slate-400'>FAB GOLD © COPYRIGHT 2024. All Rights Reserved </p> 
                <Link to="https://codepublicist.com"><p className='px-5  text-slate-400'> Designed By CODE PUBLICIST</p></Link>
            </div>
            <div className='flex lg:flex-row md:flex-col max-sm:flex-col sm:flex-col sm:items-center max-sm:items-center md:items-center'>
               <Link to="/terms" onClick={scrollToTop}> <p className='text-slate-400'>Terms & Conditions </p> </Link>
               <Link to="/privacy" onClick={scrollToTop}> <p className='px-5 text-slate-400'> Privacy Policy</p> </Link>
            </div>
        </div>
    </footer>
  )
}

export default Footer